import { AttributeId as ApiAttributeId } from '@/network/graphql.g'

enum AttributeId {
  Woman = 12,
  Man = 13
}

export const convertAttributeIdToApiAttributeId = (
  attributeId: AttributeId
): ApiAttributeId => {
  switch (attributeId) {
    case AttributeId.Woman:
      return ApiAttributeId.Woman
    case AttributeId.Man:
      return ApiAttributeId.Man
    default:
      return null
  }
}

export const convertApiAttributeIdToAttributeId = (
  attributeId: ApiAttributeId
): AttributeId => {
  switch (attributeId) {
    case ApiAttributeId.Woman:
      return AttributeId.Woman
    case ApiAttributeId.Man:
      return AttributeId.Man
    default:
      return null
  }
}
